import React from 'react';
// Make sure your image paths are correct
import Image1 from "../assets/images/timeline-1.png";
import Image2 from "../assets/images/timeline-2.png";

const timelineData = [
  {
    year: '1981',
    title: 'Our Legacy: From Foundations to Frontiers',
    description: 'Established in 1981 by Mrs. Kamalini Mohapatra in collaboration with Japanese technology partners, JBS Capacitors emerged as one of Orissa’s pioneering SME manufacturing companies. With a strong foundation in the design and production of high-quality capacitors, thermistors, and resistors, we’ve garnered national recognition and multiple awards for technological excellence.',
    imageUrl: Image1,
    direction: 'left', // Text on left, Image on right
  },
  {
    year: '2025',
    title: 'Global Growth with Purpose',
    description: 'Under the visionary leadership of Dr. Gayatri Mohapatra, our current Managing Director, JBS Capacitors has evolved into a private holding company with an international footprint, including active subsidiaries in the United Kingdom and clients around the world. Our journey is marked by constant diversification and iterative restructuring to align with fast-changing global markets—ensuring resilience, relevance, and consistent growth.',
    imageUrl: Image2,
    direction: 'right', // Image on left, Text on right
  },
];

const TimelineItem = ({ data }) => {
  const { year, title, description, imageUrl, direction } = data;

  // Reusable component for the text block
  const TextBlock = () => (
    <div className={`bg-slate-100 p-6 rounded-2xl flex items-center text-left gap-4 shadow-md ${direction === 'right' ? 'flex-row-reverse' : ''}`}>
      <div>
        <h3 className="font-bold text-lg text-slate-800">{title}</h3>
        <p className="text-sm text-slate-600 leading-snug mt-1">{description}</p>
      </div>
      <div className="text-6xl font-bold text-blue-600 [writing-mode:vertical-rl] rotate-180 select-none">
        {year}
      </div>
    </div>
  );

  // Reusable component for the image block
  const ImageBlock = () => (
    <img src={imageUrl} alt={title} className="w-60 h-60 rounded-full  shadow-lg object-cover" />
  );

  return (
    <div className="mb-8 flex justify-center md:justify-between flex-wrap md:flex-nowrap items-center w-full">
      {/* --- Left Side (Desktop) --- */}
      <div className="hidden md:flex w-5/12 justify-end">
        {direction === 'left' ? <TextBlock /> : <ImageBlock />}
      </div>

      {/* --- Marker --- */}
      <div className="order-1 md:order-none flex-shrink-0 w-full md:w-2/12 flex justify-center items-center">
        <div className="w-1 h-32 translate-x-12 bg-blue-600 md:hidden"></div>
        <div className="w-24 h-24 bg-blue-600 rounded-full flex-shrink-0 flex items-center justify-center text-white text-2xl font-bold z-10 select-none">
          {year}
        </div>
        {/* <div className="w-1 h-20 bg-blue-600 md:hidden"></div> */}
      </div>

      {/* --- Right Side (Desktop) --- */}
      <div className="hidden md:flex w-5/12 justify-start">
        {direction === 'right' ? <TextBlock /> : <ImageBlock />}
      </div>
      
      {/* --- Content for Mobile --- */}
      <div className="md:hidden order-1 w-full mt-4 flex flex-col items-center">
        <img src={imageUrl} alt={title} className="w-60 h-60 rounded-full border-8 border-white shadow-lg object-cover" />
        <div className="bg-slate-100 p-6 rounded-2xl shadow-md mt-4 text-center">
          <h3 className="font-bold text-lg text-slate-800">{title}</h3>
          <p className="text-sm text-slate-600 leading-snug mt-1">{description}</p>
        </div>
      </div>
    </div>
  );
};

const Timeline = () => {
  return (
    <div className="py-12">
      <div className="container mx-auto px-4">
        <div className="relative wrap overflow-hidden h-full">
          {/* The vertical line for desktop */}
          <div className="hidden md:block absolute border-opacity-20 h-full border-2 border-blue-600 left-1/2"></div>

          {timelineData.map((item, index) => (
            <TimelineItem data={item} key={index} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Timeline;